import { render, staticRenderFns } from "./MatterList.vue?vue&type=template&id=67ec7845&scoped=true&"
import script from "./MatterList.vue?vue&type=script&lang=js&"
export * from "./MatterList.vue?vue&type=script&lang=js&"
import style0 from "./MatterList.vue?vue&type=style&index=0&id=67ec7845&prod&lang=css&"
import style1 from "./MatterList.vue?vue&type=style&index=1&id=67ec7845&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ec7845",
  null
  
)

export default component.exports